import { useEffect } from 'react'

const filloutFormId = 'vrQ8gL8h8Vus'
const filloutFormUrl = `https://forms.fillout.com/t/${filloutFormId}`
const filloutEmbedScript = 'https://server.fillout.com/embed/v1/'
const publicEmail = 'hello@informat.ie'

export function FilloutEnquiry() {
  useEffect(() => {
    if (document.querySelector(`script[src="${filloutEmbedScript}"]`)) return

    const script = document.createElement('script')
    script.src = filloutEmbedScript
    script.async = true
    script.dataset.informatFillout = 'true'
    document.body.appendChild(script)
  }, [])

  return (
    <div className="fillout-enquiry">
      <div
        aria-label="Informat project enquiry form"
        className="fillout-enquiry__embed"
        data-fillout-dynamic-resize=""
        data-fillout-embed-type="standard"
        data-fillout-id={filloutFormId}
        data-fillout-inherit-parameters=""
      />
      <noscript>
        <p>
          JavaScript is required for the embedded enquiry form.{' '}
          <a href={filloutFormUrl}>Open the enquiry form directly</a>.
        </p>
      </noscript>
      <div className="fillout-enquiry__fallback">
        <span>Prefer another route?</span>
        <div>
          <a href={filloutFormUrl}>Open the form directly</a>
          <a href={`mailto:${publicEmail}`}>{publicEmail}</a>
        </div>
      </div>
    </div>
  )
}
